import { useEffect, useState } from 'react';
import type { Product } from '../types/Product';

const RECENTLY_VIEWED_KEY = 'recentlyViewedProducts';
const MAX_RECENT_PRODUCTS = 10;

export const useRecentlyViewed = (currentProduct: Product | null) => {
  const [recentlyViewed, setRecentlyViewed] = useState<Product[]>([]);

  // Load recently viewed products from localStorage
  useEffect(() => {
    const loadRecentlyViewed = () => {
      try {
        const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
        if (stored) {
          const parsed = JSON.parse(stored);
          setRecentlyViewed(parsed);
        }
      } catch (error) {
        console.error('Error loading recently viewed products:', error);
      }
    };

    loadRecentlyViewed();
  }, []);

  // Add current product to recently viewed
  useEffect(() => {
    if (!currentProduct) return;

    try {
      const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      let recent: Product[] = stored ? JSON.parse(stored) : [];

      // Remove current product if it already exists
      recent = recent.filter((p) => p.id !== currentProduct.id);

      // Add current product to the beginning
      recent.unshift(currentProduct);

      // Keep only the most recent MAX_RECENT_PRODUCTS
      recent = recent.slice(0, MAX_RECENT_PRODUCTS);

      // Save to localStorage
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(recent));
      setRecentlyViewed(recent);
    } catch (error) {
      console.error('Error saving recently viewed product:', error);
    }
  }, [currentProduct]);

  // Filter out the current product from the list
  const filteredRecentlyViewed = currentProduct
    ? recentlyViewed.filter((p) => p.id !== currentProduct.id)
    : recentlyViewed;

  return filteredRecentlyViewed;
};
